import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import FundingAIRecommendationBadge from './FundingAIRecommendationBadge';
import { useFundingRoutes } from '../../hooks/funding/useFundingRoutes';

const FundingDashboardAdvisorPanel = ({ recommendations = [] }) => {
  const { pathFor } = useFundingRoutes();
  const advisorPath = pathFor('ai-advisor');
  const top = recommendations.slice(0, 5);

  return (
    <div className="space-y-3">
      {top.length === 0 ? (
        <p className="text-sm text-[var(--fg-muted)]">No high-priority advisor recommendations yet.</p>
      ) : (
        top.map((item) => (
          <div key={item.id} className="rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-4 py-3">
            <div className="flex items-start justify-between gap-2">
              <div>
                <div className="font-medium text-[var(--fg-text)]">{item.title}</div>
                <div className="mt-1 text-xs text-[var(--fg-muted)]">{item.summary}</div>
              </div>
              <FundingAIRecommendationBadge priority={item.priority} />
            </div>
          </div>
        ))
      )}
      <Link to={advisorPath}>
        <Button variant="outline" size="sm" className="rounded-xl">Open AI Advisor</Button>
      </Link>
    </div>
  );
};

export default FundingDashboardAdvisorPanel;
